import { css } from '@emotion/core';
export default {
  name: "quvmp5",
  styles: "padding:0;border:0;background:none;color:inherit;font-family:inherit;font-size:inherit;text-align:inherit;"
};